import React, { useEffect, useState } from "react";
import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import {
  listFinancePartners,
  updateFinancePartnerStatus
} from "../../Redux/Actions/financePartnersActions";
import { columnsFinancePartners } from "../../Global Functions/columnsAntd";

const ListFinancePartner = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const dispatch = useDispatch();
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const fetchDetails = (page, limit) => {
    const payload = {
      page,
      limit,
    };
    dispatch(listFinancePartners(payload));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const financePartners = useSelector((state) => state.finance_partners || {});

  useEffect(() => {
    if (financePartners?.total) {
      setPagination((prevData) => ({
        ...prevData,
        total: financePartners.total,
      }));
    }
  }, [financePartners]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const handleStatusChange = async (record, action) => {
    if (action === "active" || action === "inactive") {
      const payload = {
        id: record._id,
        status: action,
      };
      await dispatch(updateFinancePartnerStatus(payload));
    }

    fetchDetails(pagination.current, pagination.pageSize);
  };

  return (
    <TableComponent
      h3heading="Finance Partner List"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsFinancePartners(handleStatusChange, canEdit)}
      buttonhead2={canAdd ? "Add Finance Partner" : null}
      navigateTo2={canAdd ? "/finance_partners/add" : null}
      dataSource={Array.isArray(financePartners?.data) ? financePartners.data : []}
    />
  );
};

export default ListFinancePartner;
